import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { batch, useDispatch } from "react-redux";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const CloseDialogButton = (props) => {
    const dispatch = useDispatch();
    return React.createElement(AuxButton, { className: "hydrated", label: props?.label || language.en.common.cancel, type: AuxButtonTypeEnum.SECONDARY, key: "close-dialog-button", onClick: () => {
            batch(() => {
                dispatch(closeDialog());
            });
        } });
};
